/**
 * @see https://www.figma.com/file/16YSFRr06xdFYJFqNgvv41/Bormioli-Product-Design?node-id=1221%3A89182
 */

import { useState } from "react";
import AccordionItem, {
  AccordionItemProps,
} from "./AccordionItem/AccordionItem";
import { AccordionContainer, AccordionInner } from "./styles";

type Props = {
  _key: string;
  _type: string;
  items?: AccordionItemProps[];
};

const Accordion: React.FC<Props> = (props) => {
  const { items } = props;
  const [activeItem, setActiveItem] = useState<null | string>("");

  function handleClick(id: string | undefined) {
    if (!id) return;
    if (activeItem == id) {
      setActiveItem("");
    } else {
      setActiveItem(id);
    }
  }

  return (
    <AccordionContainer>
      <AccordionInner>
        {items &&
          items.map((item) => (
            <AccordionItem
              key={item._key}
              {...item}
              isOpen={item._key == activeItem}
              handleClick={() => handleClick(item._key)}
            />
          ))}
      </AccordionInner>
    </AccordionContainer>
  );
};

export default Accordion;
